// extracted by mini-css-extract-plugin
module.exports = {"table":"style_table__crLRI","selectedRow":"style_selectedRow__rFP_3","sortable":"style_sortable__XlVjI"};